import { getFieldsForGroups } from '../../../../shared/dpRequests';

const LIST_FIELDS = ['addresses', 'children', 'educations'];

export function selfToFormValues(self: Record<string, unknown>): Record<string, unknown> {
    const values: Record<string, unknown> = {};
    for (const field of getFieldsForGroups(['address', 'contact', 'maritalStatus', 'children', 'bankAccount'])) {
        values[field] = self[field] ?? (LIST_FIELDS.includes(field) ? [] : null);
    }
    return values;
}
